<template>
    <div class="dropdown" v-if="branches.length>0">
        <b-button-group>
            <button class="btn btn-white" @click="clear" v-if="localValue && localValue.length>0">
                <span class="fe fe-x"></span>
            </button>
            <b-dropdown variant="white" no-flip :text="label || $t( 'Branch')">
                <div
                    v-for="(branch, index) in branches"
                    :key="index"
                    class="dropdown-item pl-3"
                >
                    <b-form-checkbox v-model="localValue" :value="branch._id">
                        <avatar type="circle" v-if="branch && branch.avatar" :src="branch.avatar.url" size="avatar-xs"></avatar>
                        {{branch.name}}
                    </b-form-checkbox>
                </div>
            </b-dropdown>
        </b-button-group>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Avatar from '@/components/Avatar.vue'

    export default {
        props: ['value', 'params'],
        components: {
            Avatar
        },
        data() {
            return {
                localValue: []
            }
        },
        watch: {
            localValue(newValue) {
                this.$emit('input', newValue);
                this.$emit('change', newValue);
            }
        },
        computed: {
            ...mapGetters('my-company', {
                getCompanyFromStore: 'get'
            }),

            branches() {
                const company = this.getCompanyFromStore('mine');
                let branches = this.$copy(company.branches || []);
                branches.push({...company, _id: company.id});
                return branches
            },

            label() {
                if (this.localValue && this.localValue.name) {
                    return this.localValue.name;
                } else {
                    return false;
                }
            }
        },
        created() {
            this.localValue = this.value;
        },

        methods: {
            clear() {
                this.localValue = [];
            },
            memberStyles(color) {
                return 'border-right:3px solid ' + color;
            },

            updateValue(branches) {
                this.localValue = branches;
            },

        }

    }
</script>
